<div class="stick-top">
  <mat-toolbar>
    <mat-icon>list</mat-icon> Published Messages
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/q/queueOutMessages/0">
      <mat-icon>add</mat-icon>
      Publish new message
    </button>
    <div class="fill-space"></div>
    <micro-date-range [(unit)]="usageFilter.dateRangeUnit" [(from)]="usageFilter.from" [(fromInfinite)]="usageFilter.fromInfinite" [(until)]="usageFilter.until" [(untilInfinite)]="usageFilter.untilInfinite" ></micro-date-range>
  </div>
</div>

<micro-do-chart [smallChart]="true" [doChartFilter]="usageFilter" dateField="datetime" entityType="QUEUE_OUT_MESSAGE" filter="" groupBy="queueCarrierName"></micro-do-chart>

<table class="dataTable">
  <thead>
    <tr>
      <th class="guuidHeader">
        <div class="vbox">
          Id
          <input [(ngModel)]="filter.id">
        </div>
      </th>
      <th class="dateTimeHeader">
        <div class="vbox">
          Date
        </div>
      </th>
      <th>
        <div class="vbox">
          Queue.Carrier
          <micro-queueCarrier-select [(queueCarrierId)]="filter.queueCarrierId"></micro-queueCarrier-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          Queue.Name
          <input [(ngModel)]="filter.queueName">
        </div>
      </th>
      <th>
        <div class="vbox">
          Key
          <input [(ngModel)]="filter.key">
        </div>
      </th>
      <th>
        <div class="vbox">
          Value
          <input [(ngModel)]="filter.value">
        </div>
      </th>
      <th>
        <div class="vbox">
          Error
          <input [(ngModel)]="filter.error">
        </div>
      </th>
      <th>
        <div class="vbox">
          Enqueued
          <micro-yesNo-select [(yesNo)]="filter.enqueued" yesOption="ENQUEUED" noOption="NOT ENQUEUED"></micro-yesNo-select>
        </div>
      </th>
      <th>
        <div class="vbox">
          User
          <micro-user-select [(userId)]="filter.userId"></micro-user-select>
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let element of dataSource.data">
      <td [ngClass]="element.error ? 'CRITICAL' : ''" [matTooltip]="element.error"><a routerLink="/q/queueOutMessages/{{element.id}}">{{element.id}}</a></td>
      <td>{{element.datetime | dateTimeMs}}</td>
      <td><micro-queueCarrier-lookup [queueCarrierId]="element.queueCarrierId"></micro-queueCarrier-lookup></td>
      <td [matTooltip]="element.queueName">{{element.queueName}}</td>
      <td [matTooltip]="element.key">{{element.key}}</td>
      <td [matTooltip]="element.value">{{element.value}}</td>
      <td [matTooltip]="element.errorDetail">{{element.error}}</td>
      <td>{{element.enqueued ? 'ENQUEUED' : 'NOT ENQUEUED'}}</td>
      <td><micro-user-lookup [userId]="element.userId"></micro-user-lookup></td>
    </tr>
  </tbody>
</table>

<mat-paginator #paginator
               (page)="reload()"
               [pageSize]="10"
               [pageSizeOptions]="[5, 10, 20, 50, 100, 500]">
</mat-paginator>
